import { catchErrors } from 'puffy-core/error'
import { ApolloClient, InMemoryCache, createHttpLink, gql } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

const API_ENDPOINT = 'https://2rqcbnqa5zedzkvrxtaieya4v4.appsync-api.ap-southeast-2.amazonaws.com/graphql'

const START_QUERY = gql(`
mutation start($code:ID!) {
	task_job_start(code:$code){ 
		meta {
			status
			message
		}
		code
		instructions {
			id
			description
			type
			completion_criteria
		}
	} 
}`)

const COMPLETE_QUERY = gql(`
mutation complete($code:ID!) {
	task_job_mark_as_completed(code:$code) { 
		meta {
			status
			message
		}
		message
	} 
}`)

const _void = () => null

export const createClient = (apiKey) => {
	const httpLink = createHttpLink({
		uri: API_ENDPOINT,
	})

	const authLink = setContext((_, { headers }) => {
		return {
			headers: {
				...headers,
				'x-api-key': apiKey||''
			}
		}
	})

	const client = new ApolloClient({
		link: authLink.concat(httpLink),
		cache: new InMemoryCache()
	})

	return client
}

export const start = async (code, client) => {
	const [errors, data] = await catchErrors(client.mutate({
		mutation:START_QUERY,
		variables: {
			code
		}
	}))

	if (errors) {
		console.error(`ERROR - ${errors[0].stack||errors[0].message}`)
		if (errors.some(e => e && e.message && e.message.indexOf('ask job already completed') >=0 ))
			return {
				error: 'This task has already been completed',
				completionCriteria: null
			}
		else if (errors.some(e => e && e.message && e.message.indexOf('ask job not found') >=0 ))
			return {
				error: 'Sorry, but this code is either incorrect or not active anymore.',
				completionCriteria: null
			}
		else
			return {
				error: 'Sorry, an error occured on our side. Try again later.',
				completionCriteria: null
			}
	} else {
		const { code:echoCode, instructions, meta } = ((data||{}).data||{}).task_job_start||{}
		const { status, message } = meta || {}
		if (echoCode != code) {
			console.error(`ERROR - Corrupted data. The code returned from the server is not identical to the input code (input code: ${code}, response code: ${echoCode})`)
			return {
				error: 'Sorry, an error occured on our side. Try again later.',
				completionCriteria: null
			}
		} else if (status && status > 399 && message) {
			console.error(`ERROR - (status: ${status}) ${message}`)
			return {
				error: message,
				completionCriteria: null
			}
		} 
		const completionCriteria = (instructions||[]).map(i => {
			const { completion_criteria, ...rest } = i||{}
			let completionCriterion
			if (completion_criteria) {
				try {
					completionCriterion = JSON.parse(completion_criteria)
					// completionCriterion.completed = true
				} catch(err) {
					_void(err)
					console.error(`ERROR - Failed to parse completion_criteria to JSON (completion_criteria: ${completion_criteria})`)
				}
			}

			return {
				...(completionCriterion||{}),
				...rest
			}
		})
		return {
			error:null,
			completionCriteria
		}
	}
}

export const markAsCompleted = async (code, client) => {
	const [errors, data] = await catchErrors(client.mutate({
		mutation:COMPLETE_QUERY,
		variables: {
			code
		}
	}))

	const { status, message } = (((data||{}).data||{}).task_job_mark_as_completed||{}).meta || {}

	if (errors) {
		console.error(`ERROR - ${errors[0].stack||errors[0].message}`)
		return {
			error: `We apologize in advance but we were not able to process your reward. Please contact us on Telegram (+351964990906) using your code as a reference (code: ${code})`
		}
	} else if (status && status > 399 && message) {
		console.error(`ERROR - ${message}`)
		return {
			error: message
		}
	} else
		return {}
}










